import { Input, OnInit, Directive } from '@angular/core';
import { LayoutService } from './layout.service';
import {
  RecordCategory,
  RecordModel,
  RecordProperties,
  RecordLine,
  EventType,
} from './record-model';
import {
  FieldDataType,
  ModuleStructure,
  PortalStatusValues,
} from '../models/module-structure';
import * as moment from 'moment';
import * as g from '../globals';
import { NzModalService } from 'ng-zorro-antd/modal';

@Directive()
export abstract class Field implements OnInit {
  @Input() field: import('src/app/models/module-structure').Field;
  @Input() section: import('src/app/models/module-structure').Section;
  @Input() sectionTagName: string;
  @Input() moduleStructure: ModuleStructure;
  @Input() lineId: number;
  @Input() sectionType: number;
  @Input() recordModel: RecordModel;
  @Input() recordCategory: RecordCategory;
  @Input() recordLine: RecordLine;
  @Input() recordProperty: RecordProperties;
  @Input() actionType = '';
  @Input() width = 0;
  @Input() parentClass = '';
  scanControlVal: any;
  timeFormat = '';
  currencyField: import('../../app/models/module-structure').Field;
  @Input() isTime12hFormat = true;
  @Input() set scanControl(val: any) {
    this.scanControlVal = val;
  }

  get scanControl() {
    return this.scanControlVal;
  }

  get unitsOfMeasurmentProperty(): RecordProperties {
    const unitsOfMeasurment = this.recordLine.Properties.find(
      (f) =>
        f.Name ===
        this.field.AdditionalInformationParsed.UnitOfMeasurmentPropertyName
    );
    return unitsOfMeasurment;
  }

  get openQuantityProperty(): RecordProperties {
    const openQty = this.recordLine.Properties.find(
      (f) =>
        f.Name ===
        this.field.AdditionalInformationParsed.OpenQuantityPropertyName
    );
    if (openQty === undefined) {
      return this.recordProperty;
    } else {
      if (
        openQty.ValueAsObject === undefined ||
        openQty.ValueAsObject === '' ||
        openQty.ValueAsObject === 0
      ) {
        return this.recordProperty;
      } else {
        return openQty;
      }
    }
  }

  currency: string;
  isLoading = false;

  constructor(public layoutService: LayoutService) {}

  ngOnInit(): void {
    if (this.actionType === 'View') {
      let fieldsTobeEditableOnClose: string[] = [];
      let sectionTobeEditableOnClose: string[] = [];
      const parsed = g.parseCustomConfiguration(g.allowEditEvenWhenClose);
      const parsedSection = g.parseCustomConfiguration(
        g.allowAddLinesEvenWhenClose
      );

      if (
        parsed.hasOwnProperty(this.recordModel.ObjectKey) &&
        Array.isArray(parsed[this.recordModel.ObjectKey]) &&
        parsed[this.recordModel.ObjectKey].length > 0
      ) {
        fieldsTobeEditableOnClose = parsed[this.recordModel.ObjectKey];
      }

      if (
        parsedSection.hasOwnProperty(this.recordModel.ObjectKey) &&
        Array.isArray(parsedSection[this.recordModel.ObjectKey]) &&
        parsedSection[this.recordModel.ObjectKey].length > 0
      ) {
        sectionTobeEditableOnClose = parsedSection[this.recordModel.ObjectKey];
      }

      let sectionIsEditable =
        sectionTobeEditableOnClose.findIndex(
          (x) => x === this.sectionTagName
        ) !== -1;

      let fieldIsNotEditable =
        fieldsTobeEditableOnClose.findIndex(
          (x) => x === this.field.PropertyName
        ) === -1;

      if (!sectionIsEditable) {
        if (fieldIsNotEditable) {
          this.recordProperty.ReadOnly = true;
        }
      }
    }

    this.timeFormat = g.companyConfiguration.TimeFormat;
    this.isTime12hFormat =
      this.timeFormat === 'hh:mmtt' && this.isTime12hFormat;
    if (!this.recordCategory) {
      this.recordCategory = this.recordModel.Categories.find(
        (c) => c.Id === this.sectionTagName
      );
    }
    if (!this.recordLine) {
      this.recordLine = this.recordCategory.Lines.find(
        (l) => l.Id === this.lineId
      );
    }

    if (!this.recordProperty && this.recordLine.Properties !== undefined) {
      this.recordProperty = this.recordLine.Properties.find(
        (c) => c.Name === this.field.PropertyName
      );
    }

    if (this.recordProperty == null) {
      return;
    }

    this.recordProperty.Visible =
      this.field.AdditionalInformationParsed.Visible;
    this.recordProperty.DataType = this.field.DataType;
    this.recordProperty.Required = this.field.Required;
    this.recordProperty.Label = this.field.Label;
    if (this.field.DataType === FieldDataType.Select) {
      if (
        this.recordModel.EventType === EventType.Create ||
        this.recordLine.IsNew === true ||
        this.moduleStructure.module.AdditionalInformationParsed.IsCustomData
      ) {
        RecordModel.getOptions(
          this.field,
          this.recordModel,
          this.recordProperty,
          this.sectionTagName,
          this.lineId,
          this.recordCategory,
          this.layoutService,
          this.moduleStructure
        );
      }
    }

    if (this.field.DataType === FieldDataType.PriceLines) {
      const currencyProp = this.recordLine.Properties.find(
        (p) => p.Name === 'Currency' || p.Name === 'PriceCurrency'
      );

      if (currencyProp != null && currencyProp !== undefined) {
        this.currency = currencyProp.ValueAsObject;
      }
      this.currencyField = this.section.Fields.find(
        (f) =>
          f.PropertyName === 'Currency' ||
          f.PropertyName === 'DocCurrency' ||
          f.PropertyName === 'PriceCurrency'
      );
    }
    /*
    this.layoutService.fieldValueChanged.subscribe(
      (d: FieldValueChangedArgs) => {
        if (
          d.sectionTagName === this.sectionTagName &&
          d.line !== this.lineId
        ) {
          return;
        }

        if (d.recordModel.FormGUID !== this.recordModel.FormGUID) {
          return;
        }

        if (
          this.field.ParentProperties !== null &&
          this.field.ParentProperties.split(';').indexOf(
            `${d.sectionTagName}.${d.recordProperty.Name}`
          ) !== -1
        ) {
          if (this.field.DataType === 3) {
            this.getOptions(this.field);
          }
        }
      }
    );
    */

    if (!this.recordProperty.Initialized) {
      this.recordProperty.ReadOnly =
        this.recordProperty.ReadOnly ||
        this.field.ReadOnly ||
        (!this.field.Editable &&
          this.recordModel.EventType === EventType.Update);
    }

    if (g.userIdentity?.Area === 2) {
      if (this.field.PortalStatus === PortalStatusValues.ReadOnly) {
        this.recordProperty.ReadOnly = true;
      }
      if (
        this.actionType?.toLowerCase() === 'edit' &&
        (this.field.PortalStatus === PortalStatusValues.NotEditable ||
          this.field.PortalStatus === PortalStatusValues.NotEditableDisabled)
      ) {
        this.recordProperty.ReadOnly = true;
      }
    }

    var propsToCheck = g.childPropertiesShouldMatchParent.split(',');
    if (propsToCheck.indexOf(this.recordProperty.Name) !== -1) {
      const treeTypeProp = this.recordLine.Properties.find(
        (f) => f.Name === 'TreeType'
      );

      const treeType = treeTypeProp?.ValueAsObject;
      if (treeType === 'I' || treeType === 'iIngredient') {
        this.recordProperty.ReadOnly = true;
      }
    }

    this.initField();
  }

  initField() {}

  numberParser(value: string) {
    if (value == null) {
      return '';
    } else {
      return value.replace('%', '').replace(' ', '');
    }
  }

  checkBoxValueChanged(): void {
    if (
      this.recordProperty.ValueAsObject ===
      this.field.AdditionalInformationParsed.ValueYes
    ) {
      this.recordProperty.ValueAsObject =
        this.field.AdditionalInformationParsed.ValueNo;
    } else {
      this.recordProperty.ValueAsObject =
        this.field.AdditionalInformationParsed.ValueYes;
    }

    this.valueChanged();
  }

  dateValueChanged() {
    let dateValue = this.recordProperty.ValueAsObject;
    const additionalInfo = this.field.AdditionalInformationParsed;

    if (additionalInfo.IsDatePickerMonthMode) {
      if (additionalInfo.MonthModeBeginOfMonth) {
        dateValue = dateValue.setDate(1);
      } else if (additionalInfo.MonthModeEndOfMonth) {
        const daysInMonth = this.daysInMonth(dateValue);
        dateValue = dateValue.setDate(daysInMonth);
      }
    }

    this.recordProperty.ValueAsObject = dateValue;
    this.valueChanged();
  }

  daysInMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  checkWarningOnChange() {
    setTimeout(() => {
      let warningQueryIdToExecute =
        this.field.AdditionalInformationParsed.WarningMsgOnValueChangeQuery;
      if (warningQueryIdToExecute != null && warningQueryIdToExecute !== 0) {
        this.layoutService
          .getWarningMsgOnValueChange(
            this.recordModel,
            this.recordCategory,
            this.recordLine,
            warningQueryIdToExecute,
            this.field,
            this.moduleStructure
          )
          .subscribe((result: any[]) => {
            if (result && result.length > 0) {
              let msg = result[0].Value;
              if (msg != null && msg !== undefined && msg !== '') {
                this.layoutService.notification.warning(
                  this.layoutService.translate('System Message'),
                  this.layoutService.translate(msg),
                  { nzDuration: 4000 }
                );
              }
            }

            /*this.layoutService.modalService.confirm({
            nzTitle: this.layoutService.translate(msg),
            nzOkText: this.layoutService.translate('Yes'),
            nzCancelText: this.layoutService.translate('No'),
            nzOnOk: () => {},
            nzOnCancel: () => {
              LayoutService.setValue(
                this.recordProperty,
                12,
                this.layoutService,
                this.recordModel,
                this.lineId,
                this.sectionTagName,
                this.moduleStructure,
                true
              );
            },
          });*/
          });
      }
    }, 1500);
  }

  valueChanged() {
    const stringifiedValue = JSON.stringify(this.recordProperty.ValueAsObject);
    if (stringifiedValue.endsWith('0Z"')) {
      // tslint:disable-next-line: space-before-function-paren
      Date.prototype.toJSON = function () {
        return moment(this).format();
      };
      const stringifiedDate = JSON.stringify(this.recordProperty.ValueAsObject);
      let str = '';
      if (stringifiedDate.includes('+')) {
        str = stringifiedDate.split('+').shift();
      } else if (stringifiedDate.includes('-')) {
        str = stringifiedDate.substring(0, stringifiedDate.length - 7);
      }
      if (str.startsWith('"')) {
        str = str.replace('"', '');
      }
      this.recordProperty.ValueAsObject = str;
    } else if (
      stringifiedValue.includes('+') &&
      this.recordProperty.ValueAsObject instanceof Date
    ) {
      let str = stringifiedValue.split('+').shift();
      if (str.startsWith('"')) {
        str = str.replace('"', '');
      }
      this.recordProperty.ValueAsObject = str;
    }
    let queryIdToExecute =
      this.field.AdditionalInformationParsed.UniqueValueValidationQuery;
    if (queryIdToExecute != null && queryIdToExecute !== 0) {
      this.layoutService
        .getFieldValueValidationOnChange(
          this.recordModel,
          this.recordCategory,
          this.recordLine,
          queryIdToExecute,
          this.field,
          this.moduleStructure
        )
        .subscribe((result: any[]) => {
          console.log(result);
          let count = result[0].Value;
          if (count !== 0) {
            this.layoutService.modalService.confirm({
              nzTitle:
                'The value of the field ' +
                this.field.Label +
                ' is duplicated, are you sure to continue?',
              nzContent: '',
              nzOnCancel: () => {
                this.recordProperty.ValueAsObject = '';

                this.layoutService.triggerFieldValueChanged({
                  recordModel: this.recordModel,
                  recordProperty: this.recordProperty,
                  formId: '',
                  line: this.lineId,
                  sectionTagName: this.sectionTagName,
                  moduleStructure: this.moduleStructure,
                  internalTrigger: false,
                });
                console.log('value changed');
                if (this.field.DataType === 3) {
                  const objVal = this.recordProperty.Options.find(
                    (val) =>
                      val.Code.toString() ===
                      this.recordProperty.ValueAsObject.toString()
                  );

                  if (
                    objVal !== undefined &&
                    objVal.DBValue !== undefined &&
                    objVal.DBValue !== ''
                  ) {
                    this.recordProperty.DBValue = objVal.DBValue;
                  }
                }
                if (this.field.DataType === 16) {
                  const currencyProp = this.recordLine.Properties.find(
                    (p) => p.Name === 'Currency'
                  );
                  if (currencyProp != null && currencyProp !== undefined) {
                    this.currency = currencyProp.ValueAsObject;
                  }
                }
              },
              nzOnOk: () => {
                this.layoutService.triggerFieldValueChanged({
                  recordModel: this.recordModel,
                  recordProperty: this.recordProperty,
                  formId: '',
                  line: this.lineId,
                  sectionTagName: this.sectionTagName,
                  moduleStructure: this.moduleStructure,
                });
                console.log('value changed');
                if (this.field.DataType === 3) {
                  const objVal = this.recordProperty.Options.find(
                    (val) =>
                      val.Code.toString() ===
                      this.recordProperty.ValueAsObject.toString()
                  );

                  if (
                    objVal !== undefined &&
                    objVal.DBValue !== undefined &&
                    objVal.DBValue !== ''
                  ) {
                    this.recordProperty.DBValue = objVal.DBValue;
                  }
                }
                if (this.field.DataType === 16) {
                  const currencyProp = this.recordLine.Properties.find(
                    (p) => p.Name === 'Currency'
                  );
                  if (currencyProp != null && currencyProp !== undefined) {
                    this.currency = currencyProp.ValueAsObject;
                  }
                }
              },
            });
          } else {
            this.layoutService.triggerFieldValueChanged({
              recordModel: this.recordModel,
              recordProperty: this.recordProperty,
              formId: '',
              line: this.lineId,
              sectionTagName: this.sectionTagName,
              moduleStructure: this.moduleStructure,
              internalTrigger: false,
            });
            console.log('value changed');
            if (this.field.DataType === 3) {
              const objVal = this.recordProperty.Options.find(
                (val) =>
                  val.Code.toString() ===
                  this.recordProperty.ValueAsObject.toString()
              );

              if (
                objVal !== undefined &&
                objVal.DBValue !== undefined &&
                objVal.DBValue !== ''
              ) {
                this.recordProperty.DBValue = objVal.DBValue;
              }
            }
            if (this.field.DataType === 16) {
              const currencyProp = this.recordLine.Properties.find(
                (p) => p.Name === 'Currency'
              );
              if (currencyProp != null && currencyProp !== undefined) {
                this.currency = currencyProp.ValueAsObject;
              }
            }
          }
        });
    } else {
      this.layoutService.triggerFieldValueChanged({
        recordModel: this.recordModel,
        recordProperty: this.recordProperty,
        formId: '',
        line: this.lineId,
        sectionTagName: this.sectionTagName,
        moduleStructure: this.moduleStructure,
        internalTrigger: false,
      });
      console.log('value changed');
      if (this.field.DataType === 3) {
        const objVal = this.recordProperty.Options.find(
          (val) =>
            val.Code.toString() === this.recordProperty.ValueAsObject.toString()
        );

        if (
          objVal !== undefined &&
          objVal.DBValue !== undefined &&
          objVal.DBValue !== ''
        ) {
          this.recordProperty.DBValue = objVal.DBValue;
        }
      }
      if (this.field.DataType === 16) {
        const currencyProp = this.recordLine.Properties.find(
          (p) => p.Name === 'Currency'
        );
        if (currencyProp != null && currencyProp !== undefined) {
          this.currency = currencyProp.ValueAsObject;
        }
      }
    }

    this.checkWarningOnChange();

    // if (this.recordModel.ModuleId === 25) {
    //   if (this.recordProperty.Name === 'AttendType') {
    //     const AssignToUser = this.moduleStructure.module.Sections
    //       .find(x => x.Id === this.section.Id).Fields
    //       .find(y => y.PropertyName === 'HandledBy');
    //     const AssignToEmployee = this.moduleStructure.module.Sections
    //       .find(x => x.Id === this.section.Id).Fields
    //       .find(y => y.PropertyName === 'HandledByEmployee')
    //     if (this.recordProperty.ValueAsObject === 'user') {
    //       AssignToEmployee.AdditionalInformationParsed.Visible = false;
    //       AssignToUser.AdditionalInformationParsed.Visible = true;
    //     }
    //     else {
    //       AssignToEmployee.AdditionalInformationParsed.Visible = true;
    //       AssignToUser.AdditionalInformationParsed.Visible = false;
    //     }
    //     console.log('Category', this.recordCategory);
    //     console.log('value', this.recordProperty.ValueAsObject);

    //   }
    // }
  }

  fieldFocusOut() {
    this.recordProperty.EditMode = false;
  }

  keyValueChanged(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.valueChanged();
    }
  }
}
